import { Component, OnInit, Inject, Output,EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExoStarService } from 'src/app/Services/ExoStar/exo-star.service';
import { ExoStar } from 'src/app/models/ExoStar';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IAttributes } from 'src/app/models/IAttributes';
import { ExostarTransaction } from 'src/app/models/ExoStarTransaction';
import { DOCUMENT } from '@angular/common';
import { toASCII } from 'punycode';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-epcs-registration',
  templateUrl: './epcs-registration.component.html',
  styleUrls: ['./epcs-registration.component.css']
})
export class EpcsRegistrationComponent implements OnInit {

  userId: string;
  userDetails: ExoStar;
  epcsRegistration: FormGroup;
  proofType: IAttributes[];
  constructor(private route: ActivatedRoute, private router: Router, private ExoStarServices: ExoStarService, private crypto: AESAlgorithm,
    private formBuilder: FormBuilder, @Inject(DOCUMENT) private document: Document, private toastr: ToastrService) { }


  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('userId');
    sessionStorage.setItem("ExoUserId", this.userId)
    this.getUserDetails();
    this.getProofType();
    this.epcsRegistration = this.formBuilder.group({
      firstName: [''],
      middleName: [''],
      lastName: [''],
      dob: [''],
      ssn: [''],
      providerId: [''],
      address1: [''],
      address2: [''],
      phone: [''],
      email: [''],
      type: [''],
      product: [''],
      license: [''],
      mobile: [''],
      serial: ['']
    })

  }

  getProofType() {
    this.ExoStarServices.getAttributes('Proof_Type').subscribe(data => {
      this.proofType = data;
    })
  }
  @Output() backtoEps = new EventEmitter();  
  getUserDetails() {
    this.ExoStarServices.getExoStarDetails(this.userId).subscribe(data => {
      this.userDetails = data;
      if (this.userDetails != null && this.userDetails != undefined) {
        this.epcsRegistration.patchValue({
          firstName: this.userDetails.firstName,
          lastName: this.userDetails.lastName,
          middleName: this.userDetails.middleName,
          providerId: this.userDetails.providerId,
          address1: this.userDetails.fullAddress,
          address2: this.userDetails.address2,
          license: this.userDetails.licenseKey,
          dob: this.userDetails.dob,
          ssn: this.userDetails.ssn,
          mobile: this.userDetails.phone,
          email: this.userDetails.emailId,
          phone: this.userDetails.phone,
          product: this.userDetails.Notes,
          type: 'EXPERIAN'
        })
      }
    })
  }
  startProofing() {
    if ((this.epcsRegistration.value.phone != "") && (this.epcsRegistration.value.email != "")) {
      this.ExoStarServices.initiateProofing(this.userId).subscribe(data => {
        this.processResponse(data)
      });
    }
    if (this.epcsRegistration.value.phone == "") {
      this.toastr.warning('Phone number cannot be empty');

    }
    if (this.epcsRegistration.value.email == "") {
      this.toastr.warning('email id cannot be empty');
    }
  }

  processResponse(transaction: ExostarTransaction) {
    if (transaction != null && transaction != undefined) {
      if (transaction.transactionStatus == 'SUCCESS') {
        if (transaction.status == 'wtg_redirect')
          this.goToUrl(transaction.response);
        else
          this.toastr.success(transaction.response);
      }
      else if (transaction.transactionStatus == 'FAILURE')
        this.toastr.error(transaction.response);
      else
        this.toastr.error(transaction.response);

    }

  }
  goToUrl(url: any): void {
    document.location.href = url;
  }

  onClickEpcsconsole() {
    this.router.navigate(['EpcsConsole'], { queryParams: { isepcs: true } });    
    this.backtoEps.emit();
  }

}
